import { render } from "./CustomerAttributes.vue?vue&type=template&id=756b87aa"
import script from "./CustomerAttributes.vue?vue&type=script&lang=js"
export * from "./CustomerAttributes.vue?vue&type=script&lang=js"

import "./CustomerAttributes.vue?vue&type=style&index=0&id=756b87aa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__